export const usersGroup = {
    'admin': 'admin',
    'agent': 'agent',
    'companyManager': 'companymanager',
    'user': 'user',
    'mister': 'mister',
}
